export const DUPLICATE_PAGE = 'REPORTING_DUPLICATE_PAGE';

export const duplicatePage = pageIndex => ({
  type: DUPLICATE_PAGE,
  pageIndex,
});
